import utils from './utils.js';
import config from './store/index.js';
/* The methods in configuration (below) are providing the prefixed url to make the switch between local and remote envirnoments during development. */
/* Mainly used from 'mock-api.js' */

const configuration = {
	mobileCheck: utils.mobilecheck()
};

export default {
	...config,
	...configuration
};



// WEBPACK FOOTER //
// ./mobile-core/src/config.js